import styles from './NoiseMeter.module.css';

import content_green from '../../assets/images/content_green.png';
import content_yellow from '../../assets/images/content_yellow.png';
import content_red from '../../assets/images/content_red.png';
import { AnimatePresence, motion } from 'motion/react';

const calculateOpacity = (
  current,
  min,
  max,
  opacityMin = 0.2,
  opacityMax = 0.5,
) => {
  return (
    ((current - min) / (max - min)) * (opacityMax - opacityMin) + opacityMin
  );
};

const NoiseMeter = ({
  noiseLevel = 0,
  prevRecord = 80,
  maxNoiseLevel = 120,
  visibleRecord,
}) => {
  const needleRotation = Math.min((noiseLevel / maxNoiseLevel) * 180 - 90, 90);
  const percentMask = (noiseLevel / maxNoiseLevel) * 50;

  const prevRecordDeg =
    ((prevRecord - maxNoiseLevel / 2) / (maxNoiseLevel / 2)) * 90;

  const prevRecordTextDeg = prevRecordDeg > 0 ? 23 : prevRecordDeg;
  const prevRecordTextX = prevRecordDeg > 0 ? 15 : -15;

  const majorTicks = Array.from({ length: 30 }, (_, i) => i * 12);
  const minorTicks = Array.from({ length: 60 }, (_, i) => i * 6);

  const centerX = 300;
  const centerY = 300;
  const radius = 225;

  const greenOpacity =
    needleRotation <= -30
      ? calculateOpacity(needleRotation, -90, -30, 0.2, 0.6)
      : 0.6;
  const yellowOpacity =
    needleRotation <= -30
      ? 0.2
      : needleRotation > -30 && needleRotation <= 30
        ? calculateOpacity(needleRotation, -30, 30, 0.2, 0.7)
        : 0.7;

  const redOpacity =
    needleRotation <= 30
      ? 0.3
      : needleRotation > 30 && needleRotation <= 90
        ? calculateOpacity(needleRotation, 30, 90, 0.3, 0.9)
        : 0.9;

  // размер всего шумометра (rem)
  const size = 92;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className={styles.noiseMeterWrapper}
      style={{ '--size': `${size}rem` }}
    >
      <AnimatePresence>
        {prevRecord && visibleRecord && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            exit={{ opacity: 0 }}
            className={styles.prevRecordBlock}
            style={{
              transform: `rotate(${prevRecordDeg}deg) translateY(-${size / 2.03}rem)`,
            }}
          />
        )}
      </AnimatePresence>

      <AnimatePresence>
        {prevRecord && visibleRecord && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            exit={{ opacity: 0 }}
            className={styles.prevRecord}
            style={{
              transform: `rotate(${prevRecordTextDeg}deg) translateY(-${size / 1.75}rem)`,
            }}
          >
            <div
              style={{
                transform: `rotate(${-prevRecordTextDeg}deg)  translateX(${prevRecordTextX}rem)`,
              }}
            >
              <span className={styles.prevText}>рекорд:</span>
              <span className={styles.prevValue}>{prevRecord}</span>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className={styles.noiseMeter}>
        <div className={styles.minLevel}>0</div>
        <div className={styles.mediumLevel}>
          {Math.round(maxNoiseLevel / 2)}
        </div>
        <div className={styles.maxLevel}>{maxNoiseLevel}</div>

        <div className={styles.circles}>
          <svg viewBox="0 0 600 600" className={styles.mainCircle}>
            <circle
              cx="50%"
              cy="50%"
              r="49%"
              fill="transparent"
              stroke="rgba(201, 255, 247, 0.9)"
              strokeWidth="3"
            />

            {majorTicks.map((angle) => (
              <line
                key={`major-${angle}`}
                x1={centerX}
                y1={centerY - radius + 10}
                x2={centerX}
                y2={centerY - radius + 50}
                stroke="#fff"
                strokeWidth="2"
                transform={`rotate(${angle} ${centerX} ${centerY})`}
              />
            ))}

            {minorTicks.map((angle) => (
              <line
                key={`minor-${angle}`}
                x1={centerX}
                y1={centerY - radius + 20}
                x2={centerX}
                y2={centerY - radius + 40}
                stroke="#fff"
                strokeWidth="4"
                filter="url(#glow)"
                transform={`rotate(${angle} ${centerX} ${centerY})`}
              />
            ))}
          </svg>

          <div className={styles.shadowTicks} />

          <div
            className={styles.sectors}
            style={{
              '--greenOpacity': greenOpacity,
              '--yellowOpacity': yellowOpacity,
              '--redOpacity': redOpacity,
            }}
          >
            <img
              src={content_green}
              alt="like"
              className={styles.content_green}
            />
            <img
              src={content_yellow}
              alt="hand"
              className={styles.content_yellow}
            />
            <img src={content_red} alt="like" className={styles.content_red} />
          </div>

          <div className={styles.smallCircle} />

          {/* <div className={styles.circleDash}>
            <svg width="200" height="200" viewBox="0 0 200 200">
              <circle
                cx="100"
                cy="100"
                r="80"
                stroke="white"
                strokeWidth="1"
                fill="none"
                strokeDasharray="60,60"
              />
            </svg>
          </div> */}

          <div
            className={styles.gradient}
            style={{
              '--percentMask': `${percentMask}%`,
              '--percentMask1': `${percentMask + 0.5}%`,
              '--needleRotation': `${needleRotation}deg`,
            }}
          />
          <div
            className={styles.line}
            style={{
              '--needleRotation': `${needleRotation}deg`,
            }}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default NoiseMeter;
